/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// react
import React from "react";
// react-dom
import { Outlet } from "react-router-dom";
// BASE components
import NavLinkAdapter from "../../../@BASE/core/NavLinkAdapter";
import BASESvgIcon from "../../../@BASE/core/BASESvgIcon";
// material ui
import IconButton from "@mui/material/IconButton";

function ListingSidebarContent(props) {
  const { resource } = props;

  return (
    <div className="flex flex-col flex-auto max-w-full w-sm">
      <IconButton
        className="absolute top-0 right-0 my-16 mx-32 z-10"
        sx={{ color: "black" }}
        component={NavLinkAdapter}
        to={`/${resource}`}
      >
        <BASESvgIcon>heroicons-outline:x</BASESvgIcon>
      </IconButton>
      <Outlet />
    </div>
  );
}

export default ListingSidebarContent;
